export const TIERS_DECLARANT_FUNDING_REFERENCE = 'TIERS_DECLARANT'

export const isTiersDeclarantPlaceholder = (ref: string | null | undefined): boolean =>
  Boolean(ref && ref.trim().toUpperCase() === TIERS_DECLARANT_FUNDING_REFERENCE)

/** Un numéro de dossier OPCO réel, pas le placeholder « tiers déclarant ». */
export const hasRecordedOpcoDossierNumber = (ref: string | null | undefined): boolean =>
  Boolean(ref && ref.trim() && !isTiersDeclarantPlaceholder(ref))

/**
 * Référence affichée à l'étape financement OPCO hors alternance (`Opco`).
 *
 * Pour un dossier OPCO EP sans numéro réel, la case « tiers déclarant » est
 * cochée par défaut. L'apprenant peut la décocher pour saisir son numéro.
 * Les autres OPCO ne reçoivent jamais ce placeholder.
 */
export function resolveOpcoFundingReference(input: {
  fundingOrganismCode: string | null | undefined
  fundingReference: string | null | undefined
  userOptedOut: boolean
}): string | null | undefined {
  const { fundingOrganismCode, fundingReference, userOptedOut } = input

  if (fundingOrganismCode !== 'OPCO_EP') {
    return isTiersDeclarantPlaceholder(fundingReference) ? '' : fundingReference
  }
  if (hasRecordedOpcoDossierNumber(fundingReference)) return fundingReference
  if (userOptedOut) return fundingReference
  return TIERS_DECLARANT_FUNDING_REFERENCE
}
